export default __webpack_public_path__ + "static/media/Arch_Elastic-Load-Balancing_64.9c2a5a44.svg";